module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vendo10-44d170b1c873f9af4dd8c7927f7ba2a9.jpg";